import React from 'react'
import ImagesContainer from '../containers/ImagesContainer'

const Home = () => {
  return (
    <div className="main-container">
      <ImagesContainer />
    </div>
  )
}
export default Home
